import { gql } from '@apollo/client'

export const CHANNEL_TYPES_QUERY = gql`
  query ChannelTypes {
    ChannelTypes {
      Name
    }
  }
`
